const DEFAULT_PROMPT = 'Ice breaking quiz for a team meeting'
const DEFAULT_CONTENT = [
  {
    questionTitle: 'What is your preferred method of communication for work-related matters?',
    slideOptions: [{ title: 'Email', correct: true }, { title: 'Phone', correct: false }, { title: 'In person', correct: false }, { title: 'Text message', correct: false }],
  },
  {
    questionTitle: 'How do you typically spend your weekends?',
    slideOptions: [{ title: 'Watching TV/Netflix', correct: false }, { title: 'Hanging out with family/friends', correct: false }, { title: 'Outdoor activities', correct: false }, { title: 'All of the above', correct: true }],
  },
  {
    questionTitle: 'What is your dream vacation spot?',
    slideOptions: [{ title: 'Beach', correct: true }, { title: 'City', correct: false }, { title: 'Nature', correct: true }, { title: 'Ski resort', correct: false }],
  },
  {
    questionTitle: 'What is your favorite movie genre?',
    slideOptions: [{ title: 'Action', correct: false }, { title: 'Drama', correct: true }, { title: 'Comedy', correct: false }, { title: 'Thriller', correct: false }],
  },
  {
    questionTitle: 'What is your favorite TV show?',
    slideOptions: [{ title: 'Friends', correct: false }, { title: 'Breaking bad', correct: false }, { title: 'Stranger Things', correct: true }, { title: 'Game of Thrones', correct: false }],
  }]

export default {
  DEFAULT_PROMPT,
  DEFAULT_CONTENT,
}
